import { render, staticRenderFns } from "./CardEnqueteRecebida.vue?vue&type=template&id=829c5bd2"
import script from "./CardEnqueteRecebida.vue?vue&type=script&lang=js"
export * from "./CardEnqueteRecebida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports